import Content from "./index";

export default {
  path: "background-jobs",
  name: "Background Jobs",
  component: Content

};
